exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vm--modal{overflow:auto\n}\n.modal-wrapper{display:flex;flex-direction:column;padding:1em\n}\n.modal-wrapper .modal-title{margin:0\n}\n.modal-wrapper .entity-search{margin-top:.5em;margin-bottom:1em\n}\n.modal-wrapper .not-found{font-style:italic;text-align:center;padding:2em\n}\n.disabled{opacity:.3;pointer-events:none;cursor:not-allowed !important\n}", ""]);

// exports
